import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IOrderReason } from "@miplatform/types";
import { getDate } from "@miplatform/utils";

export const useOrderReasons = () => {
  const stateManager = useComponentState();
  const [rescheduleReasons, setRescheduleReasons] = useState<IOrderReason[]>(
    []
  );

  const getRescheduleReasons = (options?: {
    onSuccess?: (data: IOrderReason[]) => void;
  }) => {
    return stateManager.run(async () => {
      const response = await taskService.orderReasons.getRescheduleReasons();
      if (response.status === HTTP_STATUSES.OK) {
        setRescheduleReasons(response.data);
        options?.onSuccess?.(response.data);
      }
      return response;
    });
  };

  const updateRescheduleReasons = (
    data: IOrderReason[],
    options?: { onSuccess?: (data: IOrderReason[]) => void }
  ) => {
    return stateManager.run(async () => {
      const response = await taskService.orderReasons.updateRescheduleReasons({
        data,
        modifiedOn: getDate().toISOString(), // TODO: DP remove this requirement on the BE
        toastMessageConfig: {
          success: {
            text: `Reschedule reasons were updated.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRescheduleReasons(response.data);
        options?.onSuccess?.(response.data);
      }
      return response;
    });
  };

  return { rescheduleReasons, getRescheduleReasons, updateRescheduleReasons };
};
